<app-header-one></app-header-one>

<div class="page-title-area page-title-bg1">
    <div class="container">
        <div class="page-title-content">
            <h2>Patient Profile</h2>
        </div>
    </div>
</div>

<section class="contact-area ptb-100">
    <div class="container">
        <div class="row">
           
            <div class="col-lg-12 col-md-12">
                <div class="contact-form">
                  
                    <form id="contactForm">
                        <div class="row">
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group mb-3">
                                    <label>Full Name <span>*</span></label>
                                    <input
                                        type="text"
                                        name="txtFullName"
                                        id="txtFullName"
                                        class="form-control"
                                        placeholder="Your Name"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group mb-3">
                                    <label
                                        >Email <span>*</span></label
                                    >
                                    <input
                                        type="email"
                                        name="txtEmail"
                                        id="txtEmail"
                                        class="form-control"
                                        placeholder="Your Email"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group mb-3">
                                    <label
                                        >Phone Number
                                        <span>*</span></label
                                    >
                                    <input
                                        type="text"
                                        name="txtPhoneNumber"
                                        id="txtPhoneNumber"
                                        class="form-control"
                                        placeholder="Your Phone Number"
                                    />
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <div class="form-group mb-3">
                                    <label>Profile Image <span>*</span></label>

                                    <input
                                        class="form-control inp-file"
                                        type="file"
                                        name="txtProfileImage"
                                        id="txtProfileImage"
                                        (change)="onChange($event)"
                                    />
                                </div>
                            </div>
                         
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group mb-3">
                                    <label
                                        >Password <span>*</span></label
                                    >
                                    <input
                                        type="password"
                                        name="txtPassword"
                                        id="txtPassword"
                                        class="form-control"
                                        placeholder="Your Password"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group mb-3">
                                    <label
                                        >Confirm Password
                                        <span>*</span></label
                                    >
                                    <input
                                        type="password"
                                        name="txtConfirmPassword"
                                        id="txtConfirmPassword"
                                        class="form-control"
                                        placeholder="Confirm Password"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 text-center">
                                <button type="submit" class="default-btn submit-btn">
                                    Submit
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>

